import React, { useState, useRef, useEffect, useCallback } from "react";
import Dropzone, { useDropzone } from "react-dropzone";
import styled from "styled-components";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Popup, Icon, Button, Message } from "semantic-ui-react";

import {
    SG_ADD_FILE_UPLOAD,
    CLEAR_CREATED_FILE_UPLOAD,
} from "constants/actions";

const FileUpload = ({
    organizationId,
    setShowReportId,
    setShowPage,
    AllPageOptions,
}) => {
    const dispatch = useDispatch();
    // fakeImage.image_url

    const setEditorRef = useRef(null);

    // const [employee, setEmployee] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const { addToast } = useToasts();

    // const { get_employees } = useSelector(
    //     (state) => ({
    //         get_employees: state.employees,
    //     }),
    //     shallowEqual
    // );
    // useEffect(() => {
    //     if (get_employees) {
    //         setEmployee(get_employees[employee_id]);
    //         if (get_employees[employee_id]?.picture) {

    //         }
    //     }
    // }, [get_employees, employee_id]);
    // const event = new Date();
    // const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

    // console.log(event.toLocaleDateString(undefined, options));

    useEffect(() => {
        dispatch({
            type: CLEAR_CREATED_FILE_UPLOAD,
        });
    }, [dispatch]);

    const { get_file_uploads } = useSelector(
        (state) => ({
            get_file_uploads: state.fileupload,
        }),
        shallowEqual
    );

    useEffect(() => {
        if (get_file_uploads?.created?.id) {
            setShowPage(AllPageOptions[1]);
            setShowReportId(get_file_uploads?.created?.id);
        }
    }, [get_file_uploads, setShowReportId, setShowPage, AllPageOptions]);

    // console.log(get_file_uploads?.created)

    const onClickSave = () => {
        const event = new Date();
        const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        };

        const TodayDate = event.toLocaleDateString(undefined, options);
        // console.log(image_file)
        if (organizationId) {
            // // update employee
            dispatch({
                type: SG_ADD_FILE_UPLOAD,
                payload: {
                    name: `Uploaded on ${TodayDate}`,
                    organization: organizationId,
                    data_file: uploadedFiles,
                    file_type: 3,
                },
            });
            // setOpen(false)
            setUploadedFiles(false);
            addToast("File Successfully Uploaded", {
                appearance: "success",
                autoDismiss: true,
            });
        }
    };

    const handleDrop = (dropped) => {
        // console.log(dropped)
        if (dropped[0]?.name.split(".").pop() == "csv") {
            setUploadedFiles(dropped[0]);
        } else {
            setErrorMessage(`The file ${dropped[0]?.name} is not a CSV file`);
        }
    };

    // const onDrop = useCallback(acceptedFiles => {
    //     // Do something with the files
    //     // setUploadedFiles(acceptedFiles[0])
    // }, [])

    const { acceptedFiles, fileRejections, getRootProps, getInputProps } =
        useDropzone({
            // accept: 'image/jpeg, image/png',
            accept: "text/csv",
            // onDrop
        });

    // const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    // console.log('uploadedFiles', uploadedFiles)
    // console.log('acceptedFiles', acceptedFiles)
    // console.log("fileRejections", fileRejections[0]?.errors[0]?.message)
    // console.log(errorMessage)

    // fileRejections[0]?.errors
    useEffect(() => {
        setErrorMessage(fileRejections[0]?.errors[0]?.message);
    }, [fileRejections]);

    // useEffect(() => {
    //     setUploadedFiles(acceptedFiles[0])
    // }, [acceptedFiles]);

    return (
        <UploadContainer>
            {/* Error Message */}
            {errorMessage && (
                <ErrorNotification>
                    <ErrorHeader>
                        <ErrorIcon>⚠</ErrorIcon>
                        <ErrorText>
                            <ErrorTitle>Upload error</ErrorTitle>
                            <ErrorMessage>{errorMessage}</ErrorMessage>
                        </ErrorText>
                    </ErrorHeader>
                    <CloseButton onClick={() => setErrorMessage(false)}>×</CloseButton>
                </ErrorNotification>
            )}

            {/* Upload Section */}
            <UploadSection>
                <UploadHeader>
                    <UploadTitle>Upload CSV File</UploadTitle>
                    <UploadDescription>
                        Drag and drop your CSV file here, or click to browse
                    </UploadDescription>
                </UploadHeader>

                <Dropzone
                    onDrop={handleDrop}
                    noKeyboard
                    maxFiles={1}
                    multiple={false}
                >
                    {({ getRootProps, getInputProps }) => (
                        <DropzoneArea
                            {...getRootProps()}
                            hasFile={!!uploadedFiles?.name}
                        >
                            {uploadedFiles?.name ? (
                                <FilePreview>
                                    <FileInfo>
                                        <FileIcon>📄</FileIcon>
                                        <FileName>{uploadedFiles?.name}</FileName>
                                    </FileInfo>
                                    <RemoveButton
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setUploadedFiles([]);
                                        }}
                                    >
                                        ×
                                    </RemoveButton>
                                </FilePreview>
                            ) : (
                                <DropzoneContent>
                                    <UploadIcon>⬆</UploadIcon>
                                    <DropzoneText>
                                        Drag and drop CSV files here, or click to select files
                                    </DropzoneText>
                                    <DropzoneSubtext>
                                        Only CSV files are supported
                                    </DropzoneSubtext>
                                </DropzoneContent>
                            )}
                            <input {...getInputProps()} />
                        </DropzoneArea>
                    )}
                </Dropzone>

                {/* Upload Button */}
                {uploadedFiles?.name && (
                    <UploadButtonContainer>
                        <UploadButton onClick={onClickSave}>
                            <ButtonIcon>⬆</ButtonIcon>
                            Upload File
                        </UploadButton>
                    </UploadButtonContainer>
                )}
            </UploadSection>
        </UploadContainer>
    );
};

export default FileUpload;

// Main Container
const UploadContainer = styled.div`
    background: white;
    font-family: "Poppins", sans-serif;
    padding: 24px;
`;

// Error Notification
const ErrorNotification = styled.div`
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 24px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    animation: slideDown 0.3s ease-out;

    @keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
`;

const ErrorHeader = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 12px;
`;

const ErrorIcon = styled.div`
    color: #dc2626;
    font-size: 20px;
    line-height: 1;
    margin-top: 1px;
`;

const ErrorText = styled.div`
    flex: 1;
`;

const ErrorTitle = styled.div`
    font-weight: 600;
    font-size: 14px;
    color: #dc2626;
    margin-bottom: 4px;
`;

const ErrorMessage = styled.div`
    font-size: 14px;
    color: #7f1d1d;
    line-height: 1.4;
`;

const CloseButton = styled.button`
    background: transparent;
    border: none;
    color: #dc2626;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
        background: #fee2e2;
    }
`;

// Upload Section
const UploadSection = styled.div`
    /* Upload section container */
`;

const UploadHeader = styled.div`
    text-align: center;
    margin-bottom: 24px;
`;

const UploadTitle = styled.h3`
    font-weight: 600;
    font-size: 20px;
    color: #1f2937;
    margin: 0 0 8px 0;
`;

const UploadDescription = styled.p`
    font-size: 14px;
    color: #6b7280;
    margin: 0;
    line-height: 1.5;
`;

// Dropzone Components
const DropzoneArea = styled.div`
    border: 2px dashed ${(props) => (props.hasFile ? '#476dfa' : '#d1d5db')};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: ${(props) => (props.hasFile ? 'default' : 'pointer')};
    transition: all 0.2s ease;
    background: ${(props) => (props.hasFile ? '#f8f9ff' : 'white')};
    margin-bottom: 24px;

    &:hover {
        border-color: ${(props) => (props.hasFile ? '#476dfa' : '#9ca3af')};
        background: ${(props) => (props.hasFile ? '#f8f9ff' : '#f9fafb')};
    }
`;

const DropzoneContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
`;

const UploadIcon = styled.div`
    font-size: 48px;
    color: #9ca3af;
    margin-bottom: 8px;
`;

const DropzoneText = styled.p`
    font-size: 16px;
    color: #374151;
    font-weight: 500;
    margin: 0;
`;

const DropzoneSubtext = styled.p`
    font-size: 14px;
    color: #6b7280;
    margin: 0;
`;

// File Preview
const FilePreview = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 16px;
`;

const FileInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const FileIcon = styled.div`
    font-size: 24px;
`;

const FileName = styled.div`
    font-weight: 500;
    color: #1f2937;
    font-size: 14px;
`;

const RemoveButton = styled.button`
    background: transparent;
    border: none;
    color: #dc2626;
    font-size: 20px;
    cursor: pointer;
    padding: 4px;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    transition: background-color 0.2s ease;

    &:hover {
        background: #fee2e2;
    }
`;

// Upload Button
const UploadButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
`;

const UploadButton = styled.button`
    background: transparent;
    color: #476dfa;
    border: none;
    border-radius: 6px;
    padding: 12px 20px;
    font-family: "Poppins", sans-serif;
    font-weight: 600;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        color: #3d5ce6;
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

const ButtonIcon = styled.span`
    font-size: 16px;
    line-height: 1;
`;
